import UserCards from './user-cards';
export default UserCards;